package dev.kuml.portal.web.profile

/**
 * Client-seitige Vorpruefung des Anzeigenamens (R-23) -- reine Bequemlichkeit, exakt wie
 * `dev.kuml.portal.web.editor.GenerationReportText`s eigene Vorpruefung: massgeblich ist immer die
 * Server-Validierung (`dev.kuml.portal.server.users.DisplayNameValidator`). Die Konstante wird
 * bewusst gespiegelt, nicht geteilt (dieses Modul haengt nicht an `commonMain`, siehe
 * `build.gradle.kts`).
 */
public object DisplayNameInput {
    public const val MAX_CHARACTERS: Int = 100

    public fun normalize(raw: String): String = raw.trim().replace(Regex("[ \u00A0]{2,}"), " ")

    public fun isSubmittable(raw: String): Boolean {
        val normalized = normalize(raw)
        return normalized.isNotEmpty() && normalized.length <= MAX_CHARACTERS
    }

    /** `true`, wenn [raw] gegenueber [current] tatsaechlich eine Aenderung ist -- verhindert einen
     * PATCH (und damit einen Rate-Limit-Verbrauch) fuer einen No-op-Klick. */
    public fun isChanged(
        raw: String,
        current: String,
    ): Boolean = normalize(raw) != current

    public fun remaining(raw: String): Int = MAX_CHARACTERS - normalize(raw).length
}
